import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/components/Customer/Customer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/components/Double/Double.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/components/HomeHero/HomeHero.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/components/ProblemSolution/ProblemSolution.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/node_modules/next/dist/client/link.js");
